import { createAsyncSelectors } from '@lib/selectors';
import { ExportButton } from '@ui/general/ExportButton';
import React from 'react';

import { coreActions, PostApiVolumeTableExportRequest } from '@sonar-software/sonar-core';

export const exportStartSelectors = createAsyncSelectors((state) => state.core.dataSecurity.apiVolume.export.post);

export interface ApiVolumeTableExportButtonProps {
	request: PostApiVolumeTableExportRequest;
}

export const ApiVolumeTableExportButton: React.FC<ApiVolumeTableExportButtonProps> = ({ request }) =>
	<ExportButton
		buttonProps={ {
			id: 'api-volume-table-export-button',
			type: 'default'
		} }
		request={ {
			calendarGroupingType: request.calendarGroupingType,
			end: request.end,
			start: request.start
		} }
		resetExport={ coreActions.resetPostCoreDataSecurityApiVolumeTableExport }
		onStartExport={ coreActions.requestPostCoreDataSecurityApiVolumeTableExport }
		stateSelector={ exportStartSelectors.state } />;

